import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { ChangeOwnPasswordModal } from "./users/ChangeOwnPasswordModal";

export function ProtectedRoute() {
  const { isAuthenticated, session } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Kursiyerler her zaman mobil panelde kalir; AppShell sayfalari onlara kapali.
  if (
    session?.user?.role === "student" &&
    !location.pathname.startsWith("/m/student")
  ) {
    return <Navigate to="/m/student" replace />;
  }

  const forcePasswordChange = Boolean(session?.user?.password_reset_required);

  return (
    <>
      <Outlet />
      {forcePasswordChange && (
        <ChangeOwnPasswordModal forced onClose={() => { /* forced: kapatilamaz */ }} />
      )}
    </>
  );
}
